import React from 'react';

const NextProcessIcon = ({ width = 46, height = 57, color = "#FE531F" }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 46 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
                <path d="M4 53L23 28.5L4 4" stroke={color} strokeWidth="6.15897" strokeLinecap="round" />
                <path d="M23 53L42 28.5L23 4" stroke={color} strokeWidth="6.15897" strokeLinecap="round" />
           
        </svg>


    );
};

export default NextProcessIcon;